/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpressionHistory
 */
export interface ExpressionHistory {
    /**
     * 
     * @type {string}
     * @memberof ExpressionHistory
     */
    oldValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpressionHistory
     */
    newValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpressionHistory
     */
    correctedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpressionHistory
     */
    correctedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ExpressionHistory
     */
    correctionReason?: string;
}

/**
 * Check if a given object implements the ExpressionHistory interface.
 */
export function instanceOfExpressionHistory(value: object): value is ExpressionHistory {
    return true;
}

export function ExpressionHistoryFromJSON(json: any): ExpressionHistory {
    return ExpressionHistoryFromJSONTyped(json, false);
}

export function ExpressionHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpressionHistory {
    if (json == null) {
        return json;
    }
    return {
        
        'oldValue': json['oldValue'] == null ? undefined : json['oldValue'],
        'newValue': json['newValue'] == null ? undefined : json['newValue'],
        'correctedAt': json['correctedAt'] == null ? undefined : json['correctedAt'],
        'correctedBy': json['correctedBy'] == null ? undefined : json['correctedBy'],
        'correctionReason': json['correctionReason'] == null ? undefined : json['correctionReason'],
    };
}

export function ExpressionHistoryToJSON(json: any): ExpressionHistory {
    return ExpressionHistoryToJSONTyped(json, false);
}

export function ExpressionHistoryToJSONTyped(value?: ExpressionHistory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oldValue': value['oldValue'],
        'newValue': value['newValue'],
        'correctedAt': value['correctedAt'],
        'correctedBy': value['correctedBy'],
        'correctionReason': value['correctionReason'],
    };
}

